import styled from 'styled-components/macro';
import { active_project, static_assets } from 'state/store.global';
import { useAtomValue } from 'state/jotai';
import { BREAK_ } from 'constants';
import { NavLink } from 'react-router-dom';

export const Logo = ({ link = null, device, style }) => {
  const assets = useAtomValue(static_assets);
  const obj = assets[`logo_${device}`];

  return (
    <A to={link} style={style}>
      <Wrap device={device}>
        <Img src={obj.src} alt='' device={device} />
      </Wrap>
    </A>
  );
};

export const Img = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  cursor: pointer;
`;

export const Wrap = styled.div`
  display: inline-block;
  height: 100%;
  width: 130px;

  ${BREAK_.md_dn} {
    height: auto;
    width: 130px;
  }
`;

export const A = styled(NavLink)`
  width: 100%;
  height: 100%;
  display: block;
  text-decoration: none;
`;
